export default __webpack_public_path__ + "static/media/922.090c4366.gif";